<template>
<span class="w-100">
  <!--<div v-if="category" class="product--price-info-wrapper">
    <div class="d-flex justify-content-center">
      <div class="actual-price-wrapper" v-if="product.special_price > 0 && product.special_price < product.price">
        <span class="old-price">{{$root.currency()+$root.tofixed(product.price * product_qty, 0)}}</span>
        <span class="actual-price ml-2">{{$root.currency()+$root.tofixed(product.special_price * product_qty, 0)}}</span>
		<div class="font-sm">You Save: {{$root.currency()+$root.tofixed(product.price - product.special_price, 2)}} ({{$root.currency()+$root.tofixed((product.price - product.special_price)*100/product.price, 0)}}% off)</div>
      </div>
      <div class="actual-price-wrapper" v-else>
        <span class="actual-price ml-2">{{$root.currency()+$root.tofixed(product.price * product_qty, 0)}}</span>
      </div>
      
    </div>
  </div> v-bind:class = "product.special_price > 0 && product.special_price < product.price?'product--price-info-wrapper':''" --> 
  
	<div v-if="category" class="product--price-info-wrapper">
	  <div class="d-flex justify-content-left" v-if="product.special_price > 0 && product.special_price < product.price">
		<div class="actual-price-wrapper">
		 <span class="actual-price ml-2">{{$root.currency()+$root.tofixed(product.special_price * product_qty, 0)}}</span>
		  <small class="ml-2" style="color:#93949b;"> MRP: </small><span class="old-price ">{{$root.currency()+$root.tofixed(product.price * product_qty, 0)}}</span>
		 
		</div>
		<div class="discount-wrapper">
		  <span class="discount-txt">{{$root.tofixed((product.price - product.special_price)*100/product.price, 0)}}% off</span>
		</div>
	  </div>
	  <div class="d-flex justify-content-left pl-2" v-else>
		<div class="actual-price-wrapper-price">
		  <span class="actual-price">{{$root.currency()+$root.tofixed(product.price * product_qty, 0)}}</span>                    
		</div>                   
	  </div>
	</div>
	<div v-if="shareitem" class="product--price-info-wrapper">
	  <div class="d-flex justify-content-center" v-if="product.special_price > 0 && product.special_price < product.price">
		<div class="actual-price-wrapper">
		 <span class="actual-price ml-2">{{$root.currency()+$root.tofixed(product.special_price * product_qty, 0)}}</span>
		  <small class="ml-2" style="color:#93949b;"> MRP: </small><span class="old-price ">{{$root.currency()+$root.tofixed(product.price * product_qty, 0)}}</span>
		 
		</div>
		<div class="discount-wrapper">
		  <span class="discount-txt">{{$root.tofixed((product.price - product.special_price)*100/product.price, 0)}}% off</span>
		</div>
	  </div>
	  <div class="d-flex justify-content-center pl-2" v-else>
		<div class="actual-price-wrapper-price">
		  <span class="actual-price">{{$root.currency()+$root.tofixed(product.price * product_qty, 0)}}</span>                    
		</div>                   
	  </div>
	</div>
  

  <div v-if="relative" class="related-product--price-info-wrapper">
    <div class="d-flex">
      <div class="actual-price-wrapper" v-if="product.special_price > 0 && product.special_price < product.price">
        <span class="old-price">{{$root.currency()+$root.tofixed(product.price * product_qty, 0)}}</span>
        <span class="actual-price ml-2">{{$root.currency()+$root.tofixed(product.special_price * product_qty, 0)}}</span>
      </div>
      <div class="actual-price-wrapper" v-else>
        <span class="actual-price ml-2">{{$root.currency()+$root.tofixed(product.price * product_qty, 0)}}</span>
      </div>
      <!--div class="related-product--discount-wrapper">
        <span class="discount-txt">46% off</span>
      </div-->
    </div>
  </div>

  <div v-if="details" class="product-details--price-info" >
    <b-row align-v="end" v-if="product.special_price > 0 && product.special_price < product.price">
     
      <b-col  class="mr-0 pr-0">
	  <span class="product-actual-price"> {{$root.currency()+$root.tofixed(product.special_price * product_qty, 0)}}</span>
        MRP: <span class="product-old-price">{{$root.currency()+$root.tofixed(product.price * product_qty, 0)}}</span>
     
        
        <span class="product-discount-percentage">({{$root.tofixed((product.price - product.special_price)*100/product.price, 0)}}% Off)</span>
      </b-col>
    </b-row>
	<b-row align-v="end" v-else >
		 <b-col class="pl-3 mb-1">
			 <span class="mrpactual-price">MRP: </span><span class="product-actual-price">{{$root.currency()+$root.tofixed(product.price, 0)}}</span>
		</b-col>
	</b-row>
	<b-row align-v="end">
		 <b-col class="pl-3 mb-1">
			<small style="font-size: 12px;"><strong>inclusive of all taxes</strong></small>
			
		</b-col>
	</b-row>
	
	
  </div>
  </span>
</template>

<script>
export default {
  name: "ProductPrice",
  props: {
    category:Boolean,
    details:Boolean,
    relative:Boolean,
	shareitem:Boolean,
    product:Object
  },
  data(){
    return {
      product_qty:1,
      special_price:100,
      price:200
    }
  }
};
</script>
<style scoped lang="scss">
$whiteColor: #ffffff;
$blackColor: #000000;
$themeColor2: #8507d6;
$themeColor3: #b24bf1;
$redColor: #e61583;

.product {
  &--price-info-wrapper {
    /*margin: 20px 0;*/
    width: 100%;

    .actual-price-wrapper {
      padding-right: 10px;
      border-right: 1px solid #eeeeee;

      .old-price {
        color: #93949b;
        text-decoration: line-through;
		font-size:13px;
      }

      .actual-price {
        color: #000000;
        font-weight: bold;
      }
    }

    .discount-wrapper {
      padding-left: 10px;

      .discount-txt {
        color: #ec3f79;
        font-weight: bold;
      }
    }
  }
}


.product-details {
  &--price-info {
    width: 100%;

   .product-actual-price {
      font-size: 30px;
    }
	.mrpactual-price{
	 font-size: 23px;
	}

    .product-old-price {
      text-decoration: line-through;
    }

    .product-discount-percentage {
      color: $themeColor2;
	 /* border-left: 1px solid #c6c6c6; */
		margin: 0 10px;
		padding-left: 5px
    }

    .product-old-price,
    .product-discount-percentage {
      font-size: 20px;
	  
    }
  }
}

.related-products {
  &--wrapper {
    margin-top: 100px;
    background: #f9f9f9;
    padding: 50px 0 40px;

    .related-product {
      &--price-info-wrapper {
        margin-bottom: 24px;

        .actual-price-wrapper {
          padding-right: 10px;
          border-right: 1px solid #eeeeee;

          .old-price {
            color: #93949b;
            text-decoration: line-through;
			font-size:13px;
          }

          .actual-price {
            color: $blackColor;
            font-weight: bold;
          }
        }
      }

      &--discount-wrapper {
        padding-left: 10px;

        .discount-txt {
          color: $redColor;
          font-weight: bold;
        }
      }
    }
  }

  &--txt {
    font-size: 48px;
    color: $blackColor;
    margin-bottom: 60px;
  }
}
</style>